import { Map as ImmutableMap, fromJS } from 'immutable';
import UserProfile from '../records/UserProfile';
import { FetchProfileActionTypes, UpdateProfileActionTypes } from '../actions/ProfileActions';
import { AddEmailActionTypes, DeleteEmailActionTypes, EditEmailAddressActionTypes, CancelPendingEmailAddressActionTypes, SetPrimaryActionTypes } from '../actions/EmailAddressActions';
import { handleActions } from 'flux-actions';
const initialState = new UserProfile();
export default handleActions({
  [FetchProfileActionTypes.SUCCESS](state, action) {
    if (!action.payload) {
      return state;
    }
    const pendingEmailAddress = fromJS(action.payload.data.pendingEmailAddress);
    return state.merge(new UserProfile(Object.assign({}, action.payload.data, {
      pendingEmailAddress
    })));
  },
  [UpdateProfileActionTypes.SUCCESS](state, action) {
    if (!action.payload) {
      return state;
    }
    return state.merge(new UserProfile(action.payload.props));
  },
  [EditEmailAddressActionTypes.SUCCESS](state, action) {
    if (!action.payload) {
      return state;
    }
    return state.set('pendingEmailAddress', ImmutableMap({
      email: action.payload.props
    }));
  },
  [CancelPendingEmailAddressActionTypes.SUCCESS](state) {
    return state.set('pendingEmailAddress', undefined);
  },
  [AddEmailActionTypes.SUCCESS](state, action) {
    const currentLoginEmails = state.get('loginEmails');
    if (!currentLoginEmails) {
      return state;
    }
    const loginEmails = [...currentLoginEmails];
    if (!action.payload) {
      return state;
    }
    loginEmails.push(action.payload.data);
    return state.set('loginEmails', loginEmails);
  },
  [DeleteEmailActionTypes.SUCCESS](state, action) {
    const currentLoginEmails = state.get('loginEmails');
    if (!currentLoginEmails) {
      return state;
    }
    const loginEmails = currentLoginEmails.filter(email => action.payload && email.id !== action.payload.props);
    return state.set('loginEmails', loginEmails);
  },
  [SetPrimaryActionTypes.SUCCESS](state, action) {
    const currentLoginEmails = state.get('loginEmails');
    if (!currentLoginEmails) {
      return state;
    }
    const loginEmails = currentLoginEmails.map(email => Object.assign({}, email, {
      primary: action.payload && action.payload.props === email.id
    }));
    return state.set('loginEmails', loginEmails);
  }
}, initialState);